import { Component, Input, OnInit } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { ChargeDetailPopupComponent, ChargeDetailPopupInput } from '../../charge-detail-popup/charge-detail-popup.component';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { PaymentDetailDialogComponent, PaymentDetailDialogInput } from '../../payment-detail-dialog/payment-detail-dialog.component';
import { CategoryEditorDialogComponent, CategoryEditorDialogInput } from '../../../modules/accounting/chart-of-accounts/category-editor-dialog/category-editor-dialog.component';
import { AccountEditorDialogComponent, AccountEditorDialogInput } from '../../../modules/accounting/chart-of-accounts/account-editor-dialog/account-editor-dialog.component';
import { TransactionDetailsDialogComponent, TransactionDetailsDialogInput } from '../../transaction-details-dialog/transaction-details-dialog.component';
import { ChartOfAccountsService } from '../../../../../services/accounting/chart-of-accounts.service';
import { LegFiJwtService } from '../../../../../services/auth/legfi-jwt.service';
import { JwtLegFiClaims } from '../../../../../services/auth/jwt-legfi-claims.model';

@Component({
  selector: 'app-reference-column',
  standalone: true,
    imports: [
        SharedModule,
    ],
    templateUrl: './reference-column.component.html',
})
export class ReferenceColumnComponent implements OnInit
{
    @Input() reference: {
        type: string,
        id: number,
        paymentGroupId?: number,
    } = null;

    jwt: JwtLegFiClaims;

    constructor(
            private _coa: ChartOfAccountsService,
            private _dialog: MatLegacyDialog,
    ) {
    }

    ngOnInit() {
        this.jwt = LegFiJwtService.read();
    }

    openChargeDetails() {
        const data: ChargeDetailPopupInput = {
            chargeId: this.reference.id,
        };
        this._dialog.open(ChargeDetailPopupComponent, {
            data,
        });
    }

    openPaymentGroupDetails() {
        const data: PaymentDetailDialogInput = {
            paymentGroupId: this.reference.id,
        };
        this._dialog.open(PaymentDetailDialogComponent, {
            data,
        });
    }

    openEditCategory() {
        const data: CategoryEditorDialogInput = {
            categoryId: this.reference.id,
            isNew: false,
        };
        this._dialog.open(CategoryEditorDialogComponent, {
            data,
        });
    }

    openEditAccount(type: 'asset' | 'liability' | 'equity') {
        const streams = this._coa.getOrganizationStreams(this.jwt.orgId);
        let stream = null;
        switch (type) {
            case 'asset':
                if (!streams.assets.$loaded.getValue()) {
                    this._coa.getAssets(this.jwt.orgId);
                }
                stream = streams.assets.$data;
                break;
            case 'liability':
                if (!streams.liabilities.$loaded.getValue()) {
                    this._coa.getLiabilities(this.jwt.orgId);
                }
                stream = streams.liabilities.$data;
                break;
            case 'equity':
                if (!streams.equities.$loaded.getValue()) {
                    this._coa.getEquities(this.jwt.orgId);
                }
                stream = streams.equities.$data;
                break;
            default:
                return;
        }
        stream.subscribe({
            next: (accounts) => {
                const item = accounts.find(x => x.id === this.reference.id);
                const data: AccountEditorDialogInput = {
                    create: false,
                    organizationId: this.jwt.orgId,
                    account: item,
                };
                this._dialog.open(AccountEditorDialogComponent, {
                    data,
                });
            },
        });
    }

    openViewTransaction() {
        const data: TransactionDetailsDialogInput = {
            transactionId: this.reference.id,
        };
        this._dialog.open(TransactionDetailsDialogComponent, {
            data,
        });
    }

    openRefundPaymentDetails() {
        if (!this.reference?.paymentGroupId) {
            return;
        }
        const data: PaymentDetailDialogInput = {
            paymentGroupId: this.reference.paymentGroupId,
        };
        this._dialog.open(PaymentDetailDialogComponent, {
            data,
        });
    }
}
